import { spacingMixin } from "@zillow/constellation";
import styled from "styled-components";
const Video = styled.video.withConfig({
  displayName: "Video",
  componentId: "sc-sjp072-0"
})(["display:block;", ""], spacingMixin);
export {
  Video as default
};
